import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import BaseStore from "./BaseStore";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import LoadingStates from "../constants/states/LoadingStates";


class LoginViewState {
    constructor(loadingState) {
        this.loadingState = loadingState;
    }

    equals(other) {
        return this.loadingState === other.loadingState;
    }
}

class ImmutableLoginViewStateBuilder {

    constructor() {
        this.loadingState = LoadingStates.INITIALIZED;
    }

    setLoadingState(newState) {
        this.loadingState = newState;
        return this;
    }

    build() {
        return Object.freeze(new LoginViewState(this.loadingState));
    }
}


class LoginViewStore extends BaseStore {

    constructor() {
        super(StoreUpdateEvents.LOGIN_VIEW_STORE_UPDATED, ImmutableLoginViewStateBuilder);
        this.subscribeToEvent(UIInteractionEvents.FACEBOOK_LOGIN_BUTTON_CLICKED, this.handleLoginStarted);
        this.subscribeToEvent(ActionResultEvents.SESSION_CREATED, this.resetStore);
        this.subscribeToEvent(ActionResultEvents.FB_LOGIN_FAILED, this.handleLoginFailed);
        this.subscribeToEvent(UIInteractionEvents.LOGIN_FAILED_ALERT_CLOSE, this.resetStore);
    }

    handleLoginFailed = (topic, data) => {
        return new ImmutableLoginViewStateBuilder()
            .setLoadingState(LoadingStates.FAILED_TO_LOAD)
            .build();
    };

    handleLoginStarted = (topic, data) => {
        return new ImmutableLoginViewStateBuilder()
            .setLoadingState(LoadingStates.LOADING)
            .build();
    };

}

export default new LoginViewStore();